export default "__VITE_ASSET__ef0724ba__"